import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { PriceEstimationContent, EstimationData } from '../../components/PriceEstimation/PriceEstimationContent';
import './SharedPriceEstimationPage.scss';

const SharedPriceEstimationPage: React.FC = () => {
  const { estimationId } = useParams<{ estimationId: string }>();
  const { t } = useTranslation();
  const [estimation, setEstimation] = useState<EstimationData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchReport = async () => {
      if (!estimationId) return;

      try {
        setLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/price-estimation/report/${estimationId}/public`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch report');
        }

        const data = await response.json();
        setEstimation(data);
      } catch (err) {
        console.error('Error fetching public report:', err);
        setError(t('priceEstimations.errorLoadingReport'));
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [estimationId, t]);

  if (loading) {
    return (
      <div className="shared-price-estimation-page">
        <div className="shared-price-estimation-page__loading">
          <div className="shared-price-estimation-page__spinner"></div>
          <p>{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  if (error || !estimation) {
    return (
      <div className="shared-price-estimation-page">
        <div className="shared-price-estimation-page__error">
          <p>{error || t('priceEstimations.notFound')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="shared-price-estimation-page">
      <a href="/" className="shared-price-estimation-page__brand-link">
        <img 
          src="/assets/jaakko_head.png" 
          alt="Jaakko" 
          className="shared-price-estimation-page__brand-avatar" 
        />
        <span className="shared-price-estimation-page__brand-text">
          <Trans i18nKey="priceEstimation.exploreJaakko" />
        </span>
        <svg 
          className="shared-price-estimation-page__brand-arrow" 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none"
        >
          <path 
            d="M5 12h14m-7-7l7 7-7 7" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </a>
      <div className="shared-price-estimation-page__container">
        <PriceEstimationContent estimation={estimation} />
      </div>
    </div>
  );
};

export default SharedPriceEstimationPage;

